<template>
  <div class="wrapper" v-if="!netWork">
    <div class="content">
      <div class="err-network"></div>
      <div class="txt-c mg-t-30"><el-button class="refresh-btn" @click="refresh()">刷新</el-button></div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['netWork'])
  },
  methods: {
    refresh () {
      // console.log(this.$router)
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.wrapper{
  display: flex;
  height: calc(100% - 40px);
  overflow: auto;
  padding: 20px;
  align-items: center;
  .content {
    margin: 50px auto;
  }
}
.img-auto{
  margin: 0 auto;
  display: block;
}
.refresh-btn{
  width: 120px;
  height: 48px;
  border-radius: 24px;
  background-color: #287fca;
  color: #fff;
  font-size: 20px;
}
.txt-c{
  text-align: center;
}
.mg-t-30{
  margin-top: 30px;
}
</style>
